
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"id":"action_and_navigation_icons_-_pushpin","data-name":"action and navigation icons - pushpin","d":"M15.57 13.43L21 8l-5-5-5.43 5.43a6.08 6.08 0 00-1-.27 8 8 0 00-5 .57 1 1 0 00-.3 1.63l3.89 3.89L3 19.5V21h1.5l5.25-5.25 3.89 3.89a1 1 0 001.63-.3 8 8 0 00.57-5 6.08 6.08 0 00-.27-.91z"}})])
          )
        }
      }
    